module.exports = __webpack_public_path__ + "static/media/world-icon-VP.40ce9335.png";